'use client'

import { memo } from 'react'

import { ErrorServiceUnavailable } from '@/components/common/Error'

const VaultV2SimpleActionPanelError = () => {
  return (
    <div className="contents" data-testid="vault-action-panel-error">
      <ErrorServiceUnavailable minHeight="600px" />
    </div>
  )
}

export default memo(VaultV2SimpleActionPanelError)
